<div class="suggestion-popup">
  <div class="suggestion-popup-header">
    <span class="suggestion-popup-title">{{ headerTextKey | translate }}</span>
    @if (canResolve) {
      <button
        type="button"
        class="suggestion-popup-action suggestion-popup-action-accept"
        [attr.aria-label]="'EDITOR.TRACK_CHANGES.ACCEPT' | translate"
        (mouseenter)="setHovered('accept')"
        (mouseleave)="setHovered(null)"
        (focus)="setHovered('accept')"
        (blur)="setHovered(null)"
        (click)="onAccept()"
      >
        <mat-icon>check</mat-icon>
      </button>
      <button
        type="button"
        class="suggestion-popup-action suggestion-popup-action-reject"
        [attr.aria-label]="'EDITOR.TRACK_CHANGES.REJECT' | translate"
        (mouseenter)="setHovered('reject')"
        (mouseleave)="setHovered(null)"
        (focus)="setHovered('reject')"
        (blur)="setHovered(null)"
        (click)="onReject()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <button
      type="button"
      class="suggestion-popup-action suggestion-popup-action-comment"
      [attr.aria-label]="'EDITOR.TRACK_CHANGES.POPUP_HEADER_COMMENT' | translate"
      (mouseenter)="setHovered('comment')"
      (mouseleave)="setHovered(null)"
      (focus)="setHovered('comment')"
      (blur)="setHovered(null)"
      (click)="onComment()"
    >
      <mat-icon>chat_bubble_outline</mat-icon>
    </button>
  </div>
  <app-suggestion-meta class="suggestion-popup-meta" [authorName]="authorName" [createdAtRelative]="createdAtRelative"></app-suggestion-meta>
  <div class="suggestion-popup-body">
    @for (segment of diffSegments; track $index) {
      <div
        class="suggestion-popup-diff"
        [class.suggestion-popup-diff-added]="segment.variant === 'added'"
        [class.suggestion-popup-diff-removed]="segment.variant === 'removed'"
      >
        <span class="suggestion-popup-diff-label">{{ segment.labelKey | translate }}</span>
        <span class="suggestion-popup-diff-text">
          @for (run of segment.runs; track $index) {
            <span
              [class.suggestion-popup-diff-run-bold]="run.marks.includes('strong')"
              [class.suggestion-popup-diff-run-italic]="run.marks.includes('italic')"
              >{{ run.text }}</span
            >
          }
        </span>
      </div>
    }
    @if (category === 'formatting' && formattingLabels.length > 0) {
      <div class="suggestion-popup-diff suggestion-popup-diff-formatting">
        <span class="suggestion-popup-diff-label">{{ 'EDITOR.TRACK_CHANGES.FORMATTED' | translate }}</span>
        <span class="suggestion-popup-diff-text">{{ formattingLabels.join(', ') }}</span>
      </div>
    }
    @if (hasListChanges) {
      <div class="suggestion-popup-diff suggestion-popup-diff-formatting">
        <span class="suggestion-popup-diff-label">{{ 'EDITOR.TRACK_CHANGES.STRUCTURE' | translate }}</span>
        <span class="suggestion-popup-diff-text">{{ listChangeLabels.join(', ') }}</span>
      </div>
    }
  </div>
</div>
